"use strict";

var _classCallCheck = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/yonghui/toolchain/muta-wallet/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bip39_1 = require("bip39");

var HDKey = __importStar(require("hdkey"));

var account_1 = require("../account");

var constant_1 = require("../core/constant");

var utils_1 = require("../utils");
/**
 * HD Wallet, for more information see
 * [bip32](https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki),
 * [bip39](https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki)
 * and [bip44](https://github.com/bitcoin/bips/blob/master/bip-0044.mediawiki)
 */


var HDWallet =
/*#__PURE__*/
function () {
  function HDWallet(mnemonic) {
    _classCallCheck(this, HDWallet);

    this.mnemonic = mnemonic;
  }

  _createClass(HDWallet, [{
    key: "getPrivateKey",

    /**
     * // https://github.com/bitcoin/bips/blob/master/bip-0044.mediawiki#account
     * @param accountIndex
     */
    value: function getPrivateKey(accountIndex) {
      var seed = bip39_1.mnemonicToSeedSync(this.mnemonic);
      var hd = HDKey.fromMasterSeed(seed);
      var hdInstance = hd.derive(HDWallet.getHDPath(accountIndex));
      return hdInstance._privateKey;
    }
  }, {
    key: "accountByIndex",
    value: function accountByIndex(index) {
      return account_1.SyncAccount.fromPrivateKey(utils_1.toHex(this.getPrivateKey(index)));
    }
  }], [{
    key: "fromMnemonic",
    value: function fromMnemonic(mnemonic) {
      return new HDWallet(mnemonic);
    }
  }, {
    key: "generateMnemonic",
    value: function generateMnemonic() {
      return bip39_1.generateMnemonic();
    }
  }, {
    key: "getHDPath",
    value: function getHDPath(index) {
      return "m/44'/".concat(constant_1.COIN_TYPE, "'/").concat(index, "'/0/0");
    }
  }]);

  return HDWallet;
}();

exports.HDWallet = HDWallet;